// extracted by mini-css-extract-plugin
module.exports = {"main-component":"lowPriority_main-component__2AZkq"};